<div id="drug-page-grid-controls">
  <span class="grid-control">
    <va-period-filter
      [periodData]="defaultPeriodObj"
      [filterWidthVariation]="3"
      [periodMinMax]="periodMinMax"
      (onApply)="periodSettingsChange($event)"
    ></va-period-filter>
  </span>
  <div class="grid-control">
    <app-data-revisions-dropdown
      [singleSelect]="true"
      [showReset]="true"
      [dataView]="dataView"
      (saveDataView)="updateDataView($event)"
    ></app-data-revisions-dropdown>
  </div>

  <div class="grid-control currency-filter" style="width: 78px">
    <va-currency-select
      size="small"
      selectWidth="78"
      labelPlacement="top"
      [bottomBorderView]="true"
      [(selectedCurrency)]="selectedCurrency"
      [disabled]="currencyDisabled"
      [apiEP]="apiEP"
      apiUrl="/api/get_available_currencies"
      (onChange)="onCurrencyChange($event)"
    >
    </va-currency-select>
  </div>
</div>
